import Form from 'components/Form';
import { IPatientInfo } from 'apis/admin/type';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';

interface Props {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
}

const PatientInfo = (props: Props) => {
  const {
    patientInfo: {
      patient_id,
      name,
      age,
      gender,
      ward,
      room,
      admin_hod,
      admin_pod,
      department,
      disease_main,
      main_doctor,
    },
    nurseName,
  } = props;

  const infos = [
    { title: '登記號碼.', value: patient_id },
    { title: '病人姓名', value: name },
    { title: '年齡', value: age },
    { title: '性別', value: gender },
    { title: '病房', value: ward },
    { title: '房間', value: room },
    { title: '住院日', value: admin_hod },
    { title: '術後日', value: admin_pod },
    { title: '科室', value: department },
    { title: '診斷', value: disease_main.disease_kor },
    { title: '主治醫生', value: main_doctor },
    { title: '主護理師', value: nurseName },
  ];

  return (
    <RowContainer xs={12}>
      {infos.map(({ title, value }) =>
        title === '性別' ? (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiRadioGroup
              i18nKey="GENDER"
              values={[1, 2]}
              value={Number(value)}
              defaultValue={Number(value)}
            />
          </RowContent>
        ) : (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiTextField value={value} InputProps={{ readOnly: true }} />
          </RowContent>
        )
      )}
    </RowContainer>
  );
};

export default PatientInfo;
